module.exports = __webpack_public_path__ + "05d103149f01b5649356842f4c0bf75e.otf";